import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { regenerateMessage } from 'api/ai-assistant/ai-assistant-api';

import toast from 'components/partials/toast/toast';

interface UseApiRegenerateMessageArgs {
  oktaUserId: string;
  conversationId: string;
  clientId: string | number;
}

interface RegenerateVariables {
  messageId: string;
  onChunk?: (chunk: unknown) => void;
}

interface ApiErrorLike {
  data?: { detail?: string };
}

export const useApiRegenerateMessage = ({
  oktaUserId,
  conversationId,
  clientId,
}: UseApiRegenerateMessageArgs): UseMutationResult<
  unknown,
  ApiErrorLike,
  RegenerateVariables
> =>
  useMutation<unknown, ApiErrorLike, RegenerateVariables>({
    mutationFn: ({ messageId, onChunk }) =>
      regenerateMessage({
        oktaUserId,
        conversationId,
        messageId,
        clientId,
        onChunk,
      }),
    onError: (error) =>
      toast.error({
        title: 'Error regenerating message',
        message: error?.data?.detail,
      }),
  });
